import logo from './logo.svg';
import './App.css';
import { useDebounce } from "use-debounce";
import { useEffect, useRef, useState } from 'react';
import { Button, Modal, Input, message, Upload } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import { postData } from './FetchAPI';
import { Avatar, Card, Empty } from 'antd';
import { Breadcrumb, Layout, Menu, theme } from 'antd';
import { Col, Divider, Row } from 'antd';
import { useLocation, useNavigate } from 'react-router';
import { Timeline } from 'antd';
import { Pagination } from 'antd';
import { Segmented } from 'antd';
import { Editor } from '@tinymce/tinymce-react';
import addRecipeImg from './assets/add-recipe.png';
const { Header, Content, Sider } = Layout;
const { TextArea } = Input;
const { Meta } = Card;


const template = `<h2>Recipe Title</h2>
<hr>
<h3>Ingredients:</h3>
<ul>
<li>1 cup of ingredient 1</li>
<li>2 tbsp ingredient 2</li>
<li>a dash of ingredient 3</li>
</ul>
<hr>
<h3>Instructions</h3>
<h4>Step 1.</h4>
<p>Pre-heat the oven to 350</p>
<h4>Step 2.</h4>
<p>Bake for 3 hours</p>
<h4>Step 3.</h4>
<p>Eat it</p>`


function App(props) {

  const navigate = useNavigate()

  const location = useLocation()

  useEffect(() => {
    if (location.pathname == "/recipes/") {
      setNavKey("1")
    }
    else if (location.pathname == "/timeline/") {
      setNavKey("2")
    }
    else if (location.pathname == "/users/") {
      setNavKey("3")
    }

  }, [location])

  const editorRef = useRef(null);

  const {
    token: { colorBgContainer, colorPrimaryActive },
  } = theme.useToken();

  const [recipes, setRecipes] = useState([]);
  const [reviews, setReviews] = useState([]);

  const [isRecipeModalOpen, setIsRecipeModalOpen] = useState(false);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);

  // This is used for submitting a recipe
  const [url, setUrl] = useState(null);
  // const [title, setTitle] = useState(null);
  const [recipeToggleURL, setRecipeToggleURL] = useState(true)

  // These are used for reviews
  const [reviewText, setReviewText] = useState(null);
  const [selectedRecipe, setSelectedRecipe] = useState(null);

  // These are used for users
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [newUser, setNewUser] = useState(null);


  // These are used for Search
  const [search, setSearch] = useState('');
  const [debouncedValue] = useDebounce(search, 500);
  const [blur, setBlur] = useState(false);

  const [bump, setBump] = useState(0);

  const [navKey, setNavKey] = useState("1")


  const showRecipeModal = () => { 
    if (!isRecipeModalOpen) {
      setIsRecipeModalOpen(true);
    }
    
  };

  const handleRecipeModalOk = async (data) => {
    setIsRecipeModalOpen(false);
    let recipeEndpoint = '/api/recipe/';
    let recipeTextHTML = null
    if (!url) {
      recipeTextHTML = editorRef.current.getContent();
    }
    
    await postData(recipeEndpoint, {url:url, recipe_text_html: recipeTextHTML});
    setBump(bump+1);
    message.success("Recipe Added", 8);
  };

  const handleRecipeModalCancel = () => {
    if (isRecipeModalOpen) {
      setIsRecipeModalOpen(false);
    }
  };

  const showReviewModal = (recipe) => { 
    setSelectedRecipe(recipe);
    setIsReviewModalOpen(true);
  };

  const handleReviewModalOk = async () => {
    setIsReviewModalOpen(false);
    if (reviewText) {
      await postData('/api/reviews/', {recipe:selectedRecipe.id, review: reviewText});
      setBump(bump+1)
      message.success("Review Added", 8)  
    }
  };

  const handleReviewModalCancel = () => {
    setIsReviewModalOpen(false);
  };
  
  useEffect(() => {
    const loginPromise = fetch('/api/login/');
    loginPromise.then(response => {
        return response.json();
      }).then(loggedInUser => {
        setCurrentUser(loggedInUser["username"])
        if (!loggedInUser["username"]) {
          navigate('/users/');
        }    
      });
  }, []);

  useEffect(() => {
    let recipeEndpoint = '/api/recipes/'
    if (search) {
      recipeEndpoint = recipeEndpoint + `?search=${search}`
    }
    const recipesPromise = fetch(recipeEndpoint);
    recipesPromise.then(response => {
        return response.json();
      }).then(recipes => {
        setRecipes(recipes);
        setBlur(false);
      });
  }, [bump, debouncedValue]);

  useEffect(() => {
    const reviewsPromise = fetch('/api/reviews/');
    reviewsPromise.then(response => {
        return response.json();
      }).then(reviews => {
        setReviews(reviews)
      });
  }, [bump]);

  useEffect(() => {
    const usersPromise = fetch('/api/users/');
    usersPromise.then(response => {
        return response.json();
      }).then(users => {
        setUsers(users)
      });
  }, [bump]);

  const login = async (username) => {
    await postData('/api/login/', {username:username});
    setCurrentUser(username);
    message.success("You are logged in, get cooking!", 8)
  }

  const createUser = async () => {
    await postData('/api/users/', {username:newUser});
    await login(newUser);
    setBump(bump+1);
    message.success("User Created, Let's get cooking!", 8)
  }
  
  const onChangeRecipeToggle = (value) => {
    setRecipeToggleURL(value === "url")
  }

  return (
    <Layout>
      <Header style={{display: 'flex', alignItems: 'center' }}>
        <div className="brand">🍲 Fam Cooking</div>
        <Menu theme="dark" mode="horizontal" selectedKeys={[navKey]} style={{flex: 1, minWidth: 0}}>
            <Menu.Item onClick={event => setNavKey(event.key)} key="1">Recipes</Menu.Item>
            <Menu.Item onClick={event => setNavKey(event.key)} key="2">Timeline</Menu.Item>
            <Menu.Item onClick={event => setNavKey(event.key)} key="3">Users</Menu.Item>
            <Menu.Item key="add" style={{marginLeft: 'auto'}}>
              <Button type="primary" onClick={showRecipeModal}>
              Add Recipe
              </Button>
            </Menu.Item>

        </Menu>
      </Header>
      <Layout style={{minHeight: '800px'}}>
      <Modal
        title="Add a Recipe"
        open={isRecipeModalOpen}
        onOk={handleRecipeModalOk}
        onCancel={handleRecipeModalCancel}
        okText="Add Recipe"
        width={recipeToggleURL ? 480 : 760}
      >
        <p className="modal-subtitle">Link a recipe from anywhere on the web, or write your own from scratch.</p>
        {!currentUser && (<div className="modal-warning">Please <a href="/users/">log in</a> to continue.</div>)}
        <Segmented
          block
          className="modal-segmented"
          value={recipeToggleURL ? "url" : "custom"}
          onChange={onChangeRecipeToggle}
          options={[
            { label: "Link a Recipe", value: "url" },
            { label: "Write My Own", value: "custom" },
          ]}
        />
        {recipeToggleURL && (
          <>
            <div className="field-label">Recipe URL</div>
            <Input disabled={!currentUser} placeholder="https://example.com/your-recipe" onChange={e => setUrl(e.target.value)} />
          </>
        )}
        {!recipeToggleURL && (
          <>
            <div className="field-label">Your Recipe</div>
            <Editor disabled={!currentUser} init={{branding: false}} initialValue={template} apiKey="yeihiqwyp69vo8jiyufbpp2w2x49cvxzqa0txzprorzln1zh" onInit={(evt, editor) => editorRef.current = editor} />
          </>
        )}
        </Modal>

        <Layout className="page-shell">
        <h3 className="page-heading">{currentUser && `Hello ${currentUser}!`}</h3>
          {/* <Breadcrumb style={{ margin: '16px 0' }}>
            <Breadcrumb.Item>Recipes</Breadcrumb.Item>
          </Breadcrumb> */}
          {navKey === "1" && ( <>
          <div>Search:</div>
          <Input className="search-field" onChange={e => {setBlur(true);setSearch(e.target.value)}}></Input>
          </>
          )}
          <Content
            className="page-content"
            style={{
              margin: 0,
              minHeight: 280,
              background: colorBgContainer,
            }}
          >
        {navKey === "1" && (
          <div className="recipe-grid" style={{opacity: `${blur ? ".7": "1"}`}} >
            <Card
              hoverable
              className="recipe-card add-recipe-card"
              cover={<img alt="Add a new recipe" src={addRecipeImg} />}
              onClick={showRecipeModal}
              title=""
            >
              <Meta title={"Add a new recipe!"} description={"Click Here"} />
            </Card>
          {recipes.map((recipe => {
              return <Card
              key={recipe.id}
              hoverable
              className="recipe-card"
              cover={<img alt={recipe.title} src={recipe.top_image} />}
              onClick={() => navigate(`/recipes/${recipe.id}/`)}
              // actions={[
              //   <div onClick={() => showReviewModal(recipe)} >Add Review <SettingOutlined key="setting"/></div>,
              // ]}
            >
              <Meta title={recipe.title} description={`Submitted by ${recipe?.submitter?.username}`} />
            </Card>
          }))
        }</div>
        )}
        {navKey === "2" && ( 
          
          <div>
            <h2 className="page-heading">Timeline of recent recipes the fam has cooked</h2>
            {reviews.length === 0 && (
              <Empty description="No one has logged a cooked recipe yet" style={{marginTop: 40}} />
            )}
            <Timeline >
            {
          reviews.map((review => {
            return <Timeline.Item><div>{review.created_date_ET}<Card
            extra={""}
            style={{ maxWidth: "800px", margin: '20px' }}
            title={<div>{review?.submitter?.username} cooked <b><a href={`/recipes/${review.recipe.id}/`}>{review.recipe.title}</a></b></div>}
            
          >
            <Meta 
            title={<div style={{overflow: "visible", whiteSpace: "normal"}}>{`"${review.review}"`}</div>} 
            description={`reviewed by ${review.submitter.username}`}
            avatar={<Avatar size={64} src={review.submitter.avatar_png || `https://api.dicebear.com/6.x/bottts/svg?seed=${review.submitter.username}`} />}
            />
          </Card>
          {/* <img style={{maxWidth: "200px", maxHeight: "100"}} alt="example" src={review.recipe.top_image} /> */}
            </div>
            </Timeline.Item>
        }))
      }</Timeline></div>)}
        {navKey === "3" && (
          <>
          <h3 className="page-heading">Welcome, please log in with your first name to continue</h3>
          <div className="user-list">
            {users.map((user) => (
              <div className="user-row" key={user.id}>
                <div className="user-avatar-wrap">
                  <Avatar
                    size={64}
                    src={user.avatar_png || `https://api.dicebear.com/6.x/bottts/svg?seed=${user.username}`}
                  />
                  <Upload
                    name="avatar"
                    showUploadList={false}
                    action={`/api/users/${user.id}/upload_avatar/`}
                    onChange={(info) => {
                      if (info.file.status === 'done') {
                        setBump(bump + 1);
                        message.success(`Updated ${user.username}'s avatar`, 4);
                      } else if (info.file.status === 'error') {
                        message.error('Avatar upload failed', 4);
                      }
                    }}
                  >
                    <button type="button" className="avatar-edit-badge" title="Change avatar">
                      <CameraOutlined />
                    </button>
                  </Upload>
                </div>
                <div className="user-name">{user.username}</div>
                <Button onClick={e => login(user.username)} type="primary">Log in</Button>
              </div>
            ))}
            {users.length === 0 && <Empty description="No users yet" />}
          </div>
          <div style={{marginTop: "var(--space-4)", display: "flex", flexWrap: "wrap", alignItems: "center", gap: "var(--space-2)"}}>
            <span>Don't see your name? Add yourself!</span>
            <Input className="search-field" style={{margin: 0}} placeholder="Your First Name" onChange={e => setNewUser(e.target.value)} />
            <Button onClick={async e => await createUser()} type="primary">Create User</Button>
          </div>
          </>
        )}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default App;
